import Vue from 'vue'
import VueRouter from 'vue-router'
// import pageMixin from 'mixins/page'
import platform from './platform/index'
import info from './info/index'
import im from './im/index'
import qa from './qa/index'
import topic from './topic/index'
import newFm from './newFm/index'
import cp from './cp/index'
import richText from './richText'

const notFound = () =>
  import(/* webpackChunkName: "notFound" */ 'page/notFound.vue')

Vue.use(VueRouter)

let routes = [
  ...im,
  ...info,
  ...platform,
  ...qa,
  ...topic,
  ...newFm,
  ...cp,
  ...richText,
  {
    path: '*',
    component: notFound
  }
]

export default function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
  })
  return router
}
